export default () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="100%"
      height="55"
      fill="none"
      viewBox="0 0 321 55"
    >
      <path
        d="M46.726 0H0v55h46.726V0Z"
        fill="rgb(224, 224, 224)"
      ></path>
      <path
        d="M29 13H18v29h11V13Z"
        fill="rgb(211, 211, 211)"
        stroke="rgb(189, 189, 189)"
        strokeLinejoin="round"
        strokeDasharray={2}
      ></path>
      <path
        d="M101.726 0H55v55h46.726V0Z"
        fill="rgb(224, 224, 224)"
      ></path>
      <path
        d="M84 13H73v29h11V13Z"
        fill="rgb(211, 211, 211)"
        stroke="rgb(189, 189, 189)"
        strokeLinejoin="round"
        strokeDasharray={2}
      ></path>
      <path
        d="M156.726 0H110v55h46.726V0Z"
        fill="rgb(224, 224, 224)"
      ></path>
      <path
        d="M139 13h-11v29h11V13Z"
        fill="rgb(211, 211, 211)"
        stroke="rgb(189, 189, 189)"
        strokeLinejoin="round"
        strokeDasharray={2}
      ></path>
      <path
        d="M211.726 0H165v55h46.726V0Z"
        fill="rgb(224, 224, 224)"
      ></path>
      <path
        d="M194 13h-11v29h11V13Z"
        fill="rgb(211, 211, 211)"
        stroke="rgb(189, 189, 189)"
        strokeLinejoin="round"
        strokeDasharray={2}
      ></path>
      <path
        d="M266.726 0H220v55h46.726V0Z"
        fill="rgb(224, 224, 224)"
      ></path>
      <path
        d="M249 13h-11v29h11V13Z"
        fill="rgb(211, 211, 211)"
        stroke="rgb(189, 189, 189)"
        strokeLinejoin="round"
        strokeDasharray={2}
      ></path>
      <path
        d="M321.726 0H275v55h46.726V0Z"
        fill="rgb(224, 224, 224)"
      ></path>
      <path
        d="M304 13h-11v29h11V13Z"
        fill="rgb(211, 211, 211)"
        stroke="rgb(189, 189, 189)"
        strokeLinejoin="round"
        strokeDasharray={2}
      ></path>
    </svg>
  );
};
